<template lang="pug">
.LayoutPanel(:class='{ "LayoutPanel--maximized": isMaximized, "LayoutPanel--blue": isBlueBg }')
  .LayoutPanel-header(v-if='hasHeader')
    .LayoutPanel-title.OneLine(v-html='titleHtml')
    .LayoutPanel-actions
      .LayoutPanel-group
        slot(name='actions')
      .LayoutPanel-close(v-if='closable')
        button.Btn.BtnIcon(
          @click='closePanel',
          @mouseover.stop='helperText = "Закрыть панель"',
          @mouseout.stop='helperText = null'
        )
          i.Icon.IconClose
  .LayoutPanel-content
    slot(name='content')
</template>

<script>
import helpertext from '@/mixins/helpertext'

export default {
  name: 'layout-panel',

  mixins: [helpertext],

  props: {
    hasHeader: {
      type: Boolean,
      default: true
    },
    isBlueBg: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    isMaximized: {
      type: Boolean,
      default: false
    },
    titleHtml: {
      type: String,
      default: ''
    }
  },

  methods: {
    closePanel() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
@import '~base';

#app .LayoutPanel {
  --layoutPanelText: #{$black5};
  --layoutPanelActions: #{$grey1};
  --layoutBlueBg: #{$grey7};
}

#app[data-theme='dark'] .LayoutPanel {
  --layoutPanelText: #{$grey1};
  --layoutPanelActions: #{$grey1};
  --layoutBlueBg: #{$black2};
}
</style>
<style scoped lang="scss">
.LayoutPanel {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  background: var(--appBg);

  &--blue {
    background: var(--layoutBlueBg);
  }

  &--maximized {
    position: absolute;
    z-index: 4000;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    height: auto !important;
    width: auto !important;
  }

  &-header {
    position: relative;
    flex: 0 0 auto;
    align-items: center;
    display: flex;
    padding: 0 7px 0 15px;
    border-bottom: 1px solid var(--delimiter);
    color: var(--layoutPanelText);
    font-size: 11px;
    text-transform: uppercase;
  }

  &-content {
    position: relative;
    flex: 1 1 auto;
    overflow: auto;
    height: 0;
  }

  &-title {
    flex: 1 1 auto;
  }

  &-actions {
    flex: 0 0 auto;
    margin-left: 5px;
    display: flex;
    align-items: center;
    button {
      padding: 0 5px;
      margin-left: 5px;
      color: var(--layoutPanelActions);
    }
  }

  &-group {
    display: flex;
    align-items: center;
  }

  &-close {
    .Icon {
      color: var(--layoutPanelActions);
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LayoutPanel.vue